var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResourceWebsite = function SvgResourceWebsite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.resource_website_st0{fill-rule:evenodd;clip-rule:evenodd;fill:#8295A3;fill-opacity:0.5;}\r\n\t.resource_website_st1{fill:#8295A3;}\r\n\t.resource_website_st2{fill:#FFFFFF;}\r\n\t.resource_website_st3{fill:#8295A3;stroke:#8295A3;stroke-width:1.6534;}\r\n\t.resource_website_st4{fill:#EC4C4C;}\r\n\t.resource_website_st5{fill:#F9BA48;}\r\n\t.resource_website_st6{fill:#45C94E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "resource_website_st0",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(24.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "resource_website_st1",
    d: "M70.5,0c4.8,0,8.7,3.8,8.9,8.6l0,0.3V58c0,4.8-3.8,8.7-8.6,8.9l-0.3,0H8.9c-4.8,0-8.7-3.8-8.9-8.6 L0,58V8.9C0,4.1,3.8,0.1,8.6,0l0.3,0H70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "resource_website_st2",
    d: "M70.5,4H8.9C6.3,4,4.1,6.1,4,8.7l0,0.2V58c0,2.6,2.1,4.7,4.7,4.9l0.2,0h61.6 c2.6,0,4.7-2.1,4.9-4.7l0-0.2V8.9c0-2.6-2.1-4.7-4.7-4.9L70.5,4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.800306, 28.107013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "resource_website_st1",
    d: "M10,19.5c-2.1,2.1-5.7,0.6-5.7-2.4c0-0.9,0.3-1.7,1-2.4l3.6-3.6c1.3-1.3,3.4-1.3,4.7,0 c0.8,0.8,2.2,0.8,3,0c0.8-0.8,0.8-2.2,0-3c-3-3-7.8-3-10.8,0l-3.6,3.6c-4.8,4.8-1.4,13,5.4,13c1.9,0,3.9-0.7,5.4-2.2 c0.8-0.8,0.8-2.2,0-3C12.2,18.6,10.8,18.6,10,19.5L10,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "resource_website_st1",
    d: "M15.1,2.2c-0.8,0.8-0.8,2.2,0,3c0.8,0.8,2.2,0.8,3,0c2.1-2.1,5.7-0.6,5.7,2.4 c0,0.9-0.3,1.7-1,2.4l-3.6,3.6c-1.3,1.3-3.4,1.3-4.7,0c-0.8-0.8-2.2-0.8-3,0c-0.8,0.8-0.8,2.2,0,3c3,3,7.8,3,10.8,0l3.6-3.6 c1.4-1.4,2.2-3.4,2.2-5.4C28.1,0.8,19.8-2.5,15.1,2.2L15.1,2.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    className: "resource_website_st3",
    d: "M70.1,1.6c2.2,0,4.2,0.9,5.6,2.3c1.4,1.4,2.3,3.4,2.3,5.6l0,0v6.6c-1.3,0-2.6,0-4.3-0.1 c-3.7,0-9,0-15.2,0L58,16c-21,0-51,0.1-56.6,0.1l0,0L1.3,9.5c0-2.2,0.9-4.2,2.3-5.6C5,2.5,7,1.6,9.2,1.6l0,0H70.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "resource_website_st4",
    cx: 9.1,
    cy: 9.1,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "resource_website_st5",
    cx: 15.7,
    cy: 9.1,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "resource_website_st6",
    cx: 22.3,
    cy: 9.1,
    r: 2.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourceWebsite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resource_website.7742b015.svg";
export { ForwardRef as ReactComponent };